document.addEventListener('DOMContentLoaded', function() {
    let sections = document.querySelectorAll('.section-home');

    //Si aucune section, de pas afficher
    if (sections.length === 0) {
        return;
    }

    // Création de la barre verticale
    let navBar = document.createElement('div');
    navBar.className = 'navbar-home';
    navBar.style.position = 'fixed';
    document.body.appendChild(navBar);
    
    // Créer une barre avant le premier dot
    let lineStart = document.createElement('div');
    lineStart.className = 'line-section';
    navBar.appendChild(lineStart);

    sections?.forEach((section, index) => {
        let dot = document.createElement('div');
        dot.className = 'dot-section';
        dot.dataset.sectionIndex = index;
        navBar.appendChild(dot);
    });

    // Créer une barre après le dernier dot
    let lineEnd = document.createElement('div');
    lineEnd.className = 'line-section';
    navBar.appendChild(lineEnd);

    // Fonction pour mettre à jour le dot actif en fonction de la position de défilement
    function updateActiveDot() {
        let currentSectionIndex;
        sections?.forEach((section, index) => {
            let rect = section.getBoundingClientRect();
            if (rect.top <= window.innerHeight * 0.5 && rect.bottom >= window.innerHeight * 0.5) {
                currentSectionIndex = index;
    
                // Vérifier la couleur d'arrière-plan
                let bgColor = getBackgroundColor(section);
    
                // Convertir la couleur RGB en format hexadécimal pour faciliter la comparaison
                bgColor = rgbToHex(bgColor);
    
                if(bgColor){
                    switch (bgColor) {
                        case "#040417":
                            navBar.style.mixBlendMode = 'normal';
                            break;
                        case "#ffffff":
                            navBar.style.mixBlendMode = 'darken';
                            break;
                        default:
                            navBar.style.mixBlendMode = 'plus-lighter';
                            break;  
                    }          
                }
            }
        });

        let dots = navBar.querySelectorAll('.dot-section');
        dots.forEach(dot => {
            if (dot.dataset.sectionIndex == currentSectionIndex) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
    }

    // Appeler updateActiveDot lors du chargement pour initialiser le dot actif
    updateActiveDot();

    window.addEventListener('scroll', updateActiveDot);

    navBar.addEventListener('click', function(event) {
        let dot = event.target;
        if (dot.dataset.sectionIndex) {
            let section = sections[dot.dataset.sectionIndex];
            section.scrollIntoView({
                behavior: 'smooth'
            });
        }
    });

    function getBackgroundColor(element) {
        // Retourne la couleur d'arrière-plan de l'élément
        return getComputedStyle(element).backgroundColor;
    }

    // Convertir couleur RGB en hexadécimal
    function rgbToHex(rgb) {
        // Supprimer les espaces et les séparateurs de la string
        let nums = rgb.match(/\d+/g).map(Number);
        
        // Convertir chaque composant RGB en hexadécimal et combiner
        return '#' + ((1 << 24) + (nums[0] << 16) + (nums[1] << 8) + nums[2]).toString(16).slice(1).toUpperCase();
    }
});


// document.addEventListener("DOMContentLoaded", function() {
//     let container = document.querySelector('.category-packages');
//     let cards = document.querySelectorAll('.category-packages .category-packages__card');

//     // Une fonction pour ajuster la justification
//     function adjustAlignment() {
//         // Si la première et la dernière carte ne sont pas sur la même ligne
//         if (cards[0].getBoundingClientRect().top !== cards[cards.length - 1].getBoundingClientRect().top) {
//             container.style.justifyContent = 'flex-start';
//         } else {
//             container.style.justifyContent = 'center';
//         }
//     }

//     // Ajustez la justification au chargement initial
//     adjustAlignment();

//     // Ajustez la justification également lors du redimensionnement de la fenêtre
//     window.addEventListener('resize', adjustAlignment);
// });

document.addEventListener("DOMContentLoaded", function() {
    const container = document.querySelector('.category-packages');
    const cards = document.querySelectorAll('.category-packages__card');

    function adjustContainerWidth() {

        //if container exist
        if (container) {
            container.style.width = 'auto';  // Remettre à la largeur automatique
        }

        let totalWidth = 0;
        let rowWidth = 0;

        let prevCardTop = cards[0]?.getBoundingClientRect().top;
    
        cards?.forEach(card => {
            const styles = window.getComputedStyle(card);
            const width = card.offsetWidth;
            const marginLeft = parseFloat(styles.marginLeft);
            const marginRight = parseFloat(styles.marginRight);
            const cardTotalWidth = width + marginLeft + marginRight;
            const cardTop = card.getBoundingClientRect().top;

            if (cardTop !== prevCardTop) {
                totalWidth = Math.max(totalWidth, rowWidth);
                rowWidth = 0;
            }

            rowWidth += cardTotalWidth;
            prevCardTop = cardTop;
        });

        totalWidth = Math.max(totalWidth, rowWidth);

        if(container){
            container.style.width = `${totalWidth}px`;
        }
    }

    adjustContainerWidth();
    window.addEventListener('resize', adjustContainerWidth);
});
